export default "__VITE_ASSET__xsGelvz2__"